import { Form, Formik } from 'formik';
import { useRef } from 'react';
import * as yup from 'yup';
import { forgotPasswordApi } from '../../api/auth-user-api';
import toast from 'react-hot-toast';
import { Flex } from 'antd';
import { Button, Input } from '../../common';
import { getErrorString } from '../../utils';
import ResendLink from './resendLink';
import { setCookie } from '../../utils/cookies-util';

export default function ForgotForm({ setCurrent }) {
  const formikRef = useRef();

  const getValidationSchema = () =>
    yup.object().shape({
      email: yup.string().required('Email is required').email('Valid Email is required'),
    });

  const getInitialValues = () => ({
    email: '',
  });

  const onSubmit = async (values, { setSubmitting, setStatus }) => {
    setSubmitting(true);
    try {
      const data = { email: values?.email || '' };
      const res = await forgotPasswordApi(data);
      if (res && res?.status) {
        toast.success(res?.message || '');
        setCookie('resend-link-time', new Date().getTime() + res?.reset_password_delay * 60 * 24 * 60);
        return setCurrent(1);
      } else {
        toast.error(res?.message ?? 'Request Failed');
        setStatus({ message: res?.message });
        return;
      }
    } catch (error) {
      toast.error(getErrorString(error));
      setStatus({ message: getErrorString(error) });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={getInitialValues()}
      validationSchema={getValidationSchema}
      onSubmit={onSubmit}
    >
      {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, status, setStatus }) => (
        <Form onSubmit={handleSubmit} className={'authWrap'}>
          <Flex vertical gap={24}>
            <Flex vertical gap={40}>
              <Flex vertical justify="start" align="start" gap={8}>
                <h2 className="heading-text">Forget Password</h2>
                <h5 className="subheading-text">Enter your email address to reset your password</h5>
              </Flex>
              <Input
                className={'h5-regular input-box'}
                placeholder="you@example.com"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={(values?.email || '')?.replace(/\s/g, '')}
                errorMsg={errors.email && touched.email && errors.email}
              />
            </Flex>
            <ResendLink handleSubmit={handleSubmit} isSubmitting={isSubmitting} />
          </Flex>
        </Form>
      )}
    </Formik>
  );
}
